import ClientLayout from "../components/layout/ClientLayout";
import BetHistoryContent from "./BetHistoryContent";

const BetHistory = () => {
  return (
    <ClientLayout>
      <BetHistoryContent />
    </ClientLayout>
  );
};

export default BetHistory;
